import { Component } from '@angular/core';
import { ModalService } from 'src/app/shared/components/modal/modal.service';

@Component({
  selector: 'app-restart-items',
  templateUrl: './restart-items.component.html',
  styleUrls: ['./restart-items.component.scss']
})
export class RestartItemsComponent {

  constructor(
    private modalService: ModalService
  ) { }

  public onClose(): void {
    this.modalService.closeModal(false);
  }

  public onConfirm(): void {
    this.modalService.closeModal(true);
  }
}
